import { render, staticRenderFns } from "./question-detail.vue?vue&type=template&id=4c0defd2&scoped=true&"
import script from "./question-detail.vue?vue&type=script&lang=js&"
export * from "./question-detail.vue?vue&type=script&lang=js&"
import style0 from "./question-detail.vue?vue&type=style&index=0&id=4c0defd2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0defd2",
  null
  
)

export default component.exports